export default __webpack_public_path__ + "caa5eb57d997c9fece8b63543e1c567b.png";